import { numberToCurrency } from "@/utils/money";

import { NOT_AVAILABLE } from "./messages";

const toNumber = (amount?: string | number | null): number | null => {
  if (amount === null || amount === undefined) return null;

  if (typeof amount === "number") {
    return Number.isFinite(amount) ? amount : null;
  }

  const parsed: number = Number(amount);

  return Number.isFinite(parsed) ? parsed : null;
};

export const formatAmount = (amount?: string | number | null): string => {
  const value: number | null = toNumber(amount);

  return value === null ? NOT_AVAILABLE : numberToCurrency(value);
};

export const amountToneOf = (amount?: string | number | null): string => {
  const value: number | null = toNumber(amount);

  if (value === null) return "text-gray-500";

  return value < 0 ? "text-red-600" : "text-green-600";
};
